//    ____ _____ ___  ____
//   / ___|_   _/ _ \|  _ \
//   \___ \ | || | | | |_) |
//    ___) || || |_| |  __/
//   |____/ |_| \___/|_|
//
//  This component is part of the WorkPatterns Design System.
//  Look/Feel, Styling, and Behavior have been approved by both Design and Engineering teams.
//  If changes are needed, please run these changes past @josh to ensure they are appropriate and applicable
//

// josh: Converted from TSX to JSX to use custom font awesome icons: https://nsisodiya.medium.com/hacking-font-awesome-for-custom-svg-icons-ea762118fa7b
// potential solution using TSX: https://www.codementor.io/@dopaminedriven/hacking-the-font-awesome-library-with-next-js-typescript-for-custom-icon-support-19if0bsarn
// for some reason TS is not validating the custom icon name - need to do some more research

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './WpIcon.scss';
import './FontAwesomeLibrary';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const WpIcon = ({ prefix = 'fal', size = 'md', name, color = '' }) => {
  const classNamePrefix = 'WpIcon';
  const classes = classNames(classNamePrefix, `${classNamePrefix}--${size}`);

  return <FontAwesomeIcon icon={[prefix, name]} className={classes} color={color} />;
};

WpIcon.propTypes = {
  name: PropTypes.string.isRequired,
  prefix: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  color: PropTypes.string,
};

export default WpIcon;
